import React from 'react';
import { Link } from '@99designs/ui';
import { PageType } from '../../common/types';

interface AuthLinkProps {
    children?: React.ReactNode;
    href: string;
    page: PageType;
    setPage: (page: PageType, link: string) => void;
}

export function AuthLink({ children, href, page, setPage }: AuthLinkProps) {
    function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();

        setPage(page, href);
    }

    return (
        <Link onClick={handleClick} href={href} data-testid="auth-toggle-button">
            {children}
        </Link>
    );
}
